import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FinanceService } from '../../../finance/finance.service';
import { GlobalService } from '../../services/global.service';
import { FilterService } from '../../services/filter.service';
import { SearchPipe } from '../../pipes/search.pipe';

import { tablefields } from '../../../consts/table-services';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjetcsService } from 'src/app/projects/projetcs.service';
import { MenuService } from 'src/app/shared/services/menu.service';
import * as _ from 'lodash';
import { WorkerService } from '../../services/worker.service';
import { PaginationOptions } from '../../conf/pagination-options.interface';
import { SERVICE_STATUS } from '../../conf/requirements';


@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServicesComponent implements OnInit {
	readonly SERVICE_STATUS = SERVICE_STATUS;
	loading: boolean = true;
	view: string = ''
	currentProject: any;
	project_id: any = null;
	headers: any;
	selectedItem: any;
	services: any = [];
	filteredServices: any = [];
	formLists: any = {};
	filterArguments: any = {
		'projects': [],
		'date_from': '',
		'date_to': '',
		'units': [],
		'status': [],
		'category': [],
		'vendor': [],
		'po': [],
		'includeMonthly': false,
		'search_text':''
	};
	totalServicesFiltered: number = 0;
	isRequirementsPage: boolean = false;
	paginationOptions: PaginationOptions;
	currentPage: number = 30;
	backendPaginationOptions: PaginationOptions;
	order_array: any = ['date'];
	loadingFilters: boolean = true;

	removeFromArgumentArray(list, pos) {
		list.splice(pos, 1);
		this.filter();
	}

	removeFilter(filter) {
		this.filterArguments[filter] = '';
		if(filter == 'includeMonthly') this.filterArguments[filter] = false;
		this.filter();
	}

	contextItem(ev) {
		this.selectedItem = ev;
	}

	changeView(ev) {
		this.view = ev;
	}
	changeStatus(ev) {
		var service_id = this.selectedItem.id;
		this.selectedItem.service_status_id = ev
		this.selectedItem.se_st_name_eng = "Updating"
		this.selectedItem.se_st_name_eng = "Actualizando"

		this._fiS.changeServiceStatus(service_id, ev).subscribe(
			(data: any) => {
				this.loadServ()
			})
	}

	filter(ev?){
		if (ev){
			this.filterArguments = ev;
		}
		this.resetPagination();
		localStorage.setItem('services_filter', JSON.stringify(this.filterArguments));
		this.loadData();
	}

	loadData() {
		this.view = 'home';
		this.loading = true;
		this.loadServ();

	}
	loadServ() {
		this._fiS.getFinanceServices(this.project_id, this.order_array[0], this.filterArguments, this.currentPage, this.isRequirementsPage).subscribe(
			(data: any) => {
				if(this.currentPage > data.total_pages + this.backendPaginationOptions.sliceSize){
					while (this.currentPage > data.total_pages + this.backendPaginationOptions.sliceSize) {
						this.currentPage -= this.backendPaginationOptions.sliceSize;
						this.paginationOptions.sliceStart = this.currentPage - this.backendPaginationOptions.sliceSize;
					}
					this._gS.savePagination(this.paginationOptions.sliceStart, this.paginationOptions);
					this.loadServ();
					return;
				}
				this.services = data.services ? data.services : [];
				this.filteredServices = this.services;
				this.formLists.list_po = data.list_po;
				this.formLists.list_vendor = data.list_vendor;
				this.totalServicesFiltered = data.total_cost_services;
				this.filteredServices.length = data.total_pages;
				this.loading = false;
			})
	}

	getProject() {
		this.loading = true;
		if (this._gS.projectSelected && this._gS.projectSelected.id.toString() == this.project_id.toString()) {
			this.loading = false;
			this.currentProject = this._gS.projectSelected;
			this.setBackPagination();
			this.loadData();
		} else {
			this._pS.getProjectData(this.project_id).subscribe(
				(data: any) => {
					this.loading = false;
					this.currentProject = data.project;
					this.setBackPagination();
					this.loadData();
				}
			)
		}
	}

	getServiceFilters(exportWorker: boolean = false) {
		this._fiS.getServiceFilter(this.project_id).subscribe(
			data => {
				this.formLists = {...data, ...this.formLists};
				if (!this.isRequirementsPage) {
					// won't show "New" in filter
					this.formLists.service_statuses = this.formLists.service_statuses.filter(ss => ss.id != 1);
				}
				this.loadingFilters = false;
				if(exportWorker) this.exportReportWorker('workers/caterings', 'Caterings report', 'EXCEL');
			},
			err => {
			}
		)
	}

	goBack() {
		if (this.currentProject) {
			if (this.isRequirementsPage) {
				this.router.navigate(['/projects', this.currentProject.id, 'production','requirements']);
			} else {
				this.router.navigate(['/projects', this.currentProject.id, 'finance']);
			}
		} else {
			this.router.navigate(['/finance']);
		}
	}

	setColumnsTable(params) {
		let projectColumn = this.headers.find(h => h.value == 'title');
		projectColumn.visible = params.id ? false : true;
		let startSticky = 0;
		this.headers.map(header => {
			if (header.visible && header.sticky) {
				header.sticky_value = startSticky;
				startSticky += header.width;
			}
		});
	}

	getLocalStorageData(params) {
		const FILTERS = JSON.parse(localStorage.getItem('services_filter'));
		if (FILTERS) {
			this.filterArguments = this._gS.validateFilterWithLocalStorage(FILTERS, this.filterArguments);
		}
		if (params.id) {
			this.filterArguments.projects = [];
		}
	}

	onServiceStatusChange() {
		var order = this.order_array.join(',');
		this._fiS.getFinanceServices(this.project_id, order, this.filterArguments, this.currentPage, this.isRequirementsPage).subscribe(
			(data: any) => {
				this.services = data.services;
				//this.filter();
				this.selectedItem = this.services.find(s => s.id == this.selectedItem.id);
			})
	}

	canEditService(service) {
		//New 1, Pending 2, Modified 3
		return service
			? service.service_status_id <= SERVICE_STATUS.Modified &&
			service.service_status_id != SERVICE_STATUS.Submitted
			: false;
	}

	exportResponse() {
		if(this.loadingFilters){
			this.getServiceFilters(true);
		}else{
			this.exportReportWorker('workers/services', 'Service report', 'EXCEL');
		}
	}

	exportReportWorker(url, name, type) {

		let params = {
			'projects_id': this.currentProject ? this.currentProject.id + '' : this.filterArguments.projects.map(p => p.id).join(','),
			'date_from': this.filterArguments.date_from,
			'date_to': this.filterArguments.date_to,
			'units_id': this.filterArguments.units.map(u => u.id).join(','),
			'status_id':
				this._fS.filterExcludedElements(this.filterArguments.status, this.formLists.service_statuses)
					.map(x => x.id).join(','),
			'categorys_id':
				this._fS.filterExcludedElements(this.filterArguments.category, this.formLists.service_categories)
					.map(x => x.id).join(','),
			'vendor':
				this._fS.filterExcludedElements(this.filterArguments.vendor, this.formLists.list_vendor, 'vendor')
					.map(x => x.vendor).join(','),
				'po':
					this._fS.filterExcludedElements(this.filterArguments.po, this.formLists.list_po, 'po')
						.map(x => x.po).join(','),
						'len': this._gS.getReportLenguage(),
			};

		this._wS.reportService(url, params).subscribe(
			(data: any) => {
				this.changeView('home');
				const jobId = data.report || data.job_id;
				let workerData = {
					job_id: jobId,
					job_name: name,
					job_type: type
				}
				this._wS.changeWorker(workerData);
			}
		);
	}

	orderHeaders(ev) {
		this.changeView('home');
		this.headers = ev;
		this._gS.saveHeadersTable(ev, `finance-services`);
	}

	changePagination(event, paginationOptions) {
		paginationOptions.sliceSize = this.backendPaginationOptions.sliceSize;
		this.currentPage = event == 0 ? this.backendPaginationOptions.sliceSize : event + this.backendPaginationOptions.sliceSize;
		this._gS.savePagination(event, paginationOptions);
		this.loadData();
	}

	changeViewAndGetFilters(view){
		this.view = view;
		if(this.loadingFilters) this.getServiceFilters();
	}

	getNameTable(): string{
		let projectText = this.currentProject ? '-' + this.currentProject.id : '';
		let requirementsText = this.isRequirementsPage ? 'requirements' : 'finance';
		return `${requirementsText}-services${projectText}`;
	}

	setBackPagination(){
		this.paginationOptions = this._gS.getPagination(this.getNameTable());
		this.currentPage = this.paginationOptions.sliceSize + this.paginationOptions.sliceStart;
	}

	cangeOrder(ev) {
		if (this.order_array[0] == ev) {
			this.order_array[0] = ev + ' DESC';
		} else {
			this.order_array[1] = this.order_array[0];
			this.order_array[0] = ev;
		}
		this.resetPagination();
		this.loadData();
	}

	resetPagination(){
		this.currentPage = this.backendPaginationOptions.sliceSize;
		this.paginationOptions.sliceStart = 0;
		this._gS.savePagination(this.paginationOptions.sliceStart, this.paginationOptions);
	}

	constructor(private _wS: WorkerService, private _mS: MenuService, public _pS: ProjetcsService, private route: ActivatedRoute, private router: Router, private _SearchPipe: SearchPipe, public _fiS: FinanceService, public _gS: GlobalService, public _fS: FilterService) { }

	ngOnInit() {
		this.route.params.subscribe(params => {

			this.route.data.subscribe(data => {
				this.isRequirementsPage = data.isRequirementsPage;
			});

			// needs to be a deep copy because it hides or shows project column
			this.headers = this._gS.getHeaderTable('finance-services', JSON.parse(JSON.stringify(tablefields)), 1);
			this.getLocalStorageData(params);
			this.setColumnsTable(params);
			this.backendPaginationOptions = {
				sliceStart: 0,
				sliceSize: 30,
				tableName: this.getNameTable(),
			}
			if (params.id) {
				this.project_id = params.id ? Number(params.id) : null;
				this._mS.manualChangeMenu$.next('projects');
				this.getProject();
			} else {
				this.setBackPagination();
				this.loadData();
			}
		});
	}


}
